// extracted by mini-css-extract-plugin
export default {"modal-header":"style_modal-header__R19Rg","modal-header__title":"style_modal-header__title__hmD9-","modal-header__close-button":"style_modal-header__close-button__F221-"};